import localization from './localization.js';
const maxSize = 10 * 1024 * 1024;


class measurementValidator {
    constructor() {
        this.errorMessages = {
            "doorWallWidth": {   
                required: localization.measurementsOrFloorImage,
                tooSmall:"Min 800 mm"
            },
            "depth": {    
                required: localization.measurementsOrFloorImage,
                tooSmall: "Min 800 mm"
            },
            "height":
            {
                required: localization.measurementsOrFloorImage,
                tooSmall: "Min 1700 mm"
            },
            "doorWidth":
            {
                required: localization.measurementsOrFloorImage,
                tooSmall: "Min 500 mm"
            },
            "floorImage":
            {          
                fileTooLarge: "Liitteen maksimikoko 10 MB."
            }
        };


        this.fieldValidators = {
            "doorWallWidth": {
                required: (newValue, model) => fileDefined(model.floorImage) || newValue,
                tooSmall: (newValue, model) => fileDefined(model.floorImage) || newValue >= 800
            },
            "depth": {
                required: (newValue, model) => fileDefined(model.floorImage) || newValue,
                tooSmall: (newValue, model) => fileDefined(model.floorImage) || newValue >= 800
            },
            "height":
            {
                required: (newValue, model) => fileDefined(model.floorImage) || newValue,
                tooSmall: (newValue, model) => fileDefined(model.floorImage) || newValue >= 1700
            },
            "doorWidth":
            {
                required: (newValue, model) => fileDefined(model.floorImage) || newValue,
                tooSmall: (newValue, model) => fileDefined(model.floorImage) || newValue >= 500
            },
            "floorImage":
            {
                fileTooLarge: (newValue, model) => newValue ? newValue.every(f => f.size <= maxSize) : true
            }
        };
    }
    validate(values) {
        const errors = {}
        for (let propertyName in this.fieldValidators) {
            for (let validator in this.fieldValidators[propertyName]) {
                let validatorFunction = this.fieldValidators[propertyName][validator];
                let propertyValue = values[propertyName];
                if (!validatorFunction(propertyValue, values)) {
                    errors[propertyName] = this.errorMessages[propertyName][validator];
                    break;
                }
            }
        }
        return errors;
    }
    validators(field) {

        return this.fieldValidators[field];
    }
    messages(field) {
        return this.errorMessages[field];
    }
}
export default measurementValidator;

let fileDefined = (files) => {
    return files && files.length > 0;
}